import React, { useEffect, useState } from 'react';
import { message, Spin } from 'antd';

import UserSettings from 'Src/mentorship/components/settings';
import history from 'Src/common/utilities/history';
import { applyForMentorship, getOnboardingStatus } from '../../../actions';
import { checkParams } from '../../../utils';

function Settings() {
  const [onboardingData, setOnboardingData] = useState({});
  const [loading, setLoading] = useState(true);
  const [exitMentorshipLoading, setExitMentorshipLoading] = useState(false);

  useEffect(() => {
    getOnboardingStatus()
      .then((res) => {
        setOnboardingData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    checkParams({
      name: 'update',
      callback: () => {
        message.success('Changes saved');
      },
    });
  }, []);

  const handleEditProfile = () => {
    history.push('/mentorship/onboarding?edit=true');
  };

  const handleExitMentorship = () => {
    setExitMentorshipLoading(true);
    applyForMentorship({
      form_data: {
        is_mentor: false,
        is_mentee: false,
      },
      step: 1,
      mentorship_program: window.programDetails.id,
    })
      .then(() => {
        window.open('/mentorship', '_self');
      })
      .catch(() => {
        setExitMentorshipLoading(false);
      });
  };

  return (
    <Choose>
      <When condition={loading}>
        <Spin />
      </When>
      <Otherwise>
        <UserSettings
          data={onboardingData}
          handleExitMentorship={handleExitMentorship}
          handleEditProfile={handleEditProfile}
          exitMentorshipLoading={exitMentorshipLoading} />
      </Otherwise>
    </Choose>
  );
}

export default Settings;
